<template>
    <v-dialog v-model="shows" max-width="320">
        <desc-node />
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import DescNode from "./desc/desc-node.vue";

export default {
    components: {
        DescNode,
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        ...mapState("employment/form/node", { isNodeEdit: "isEdit" }),
    },
    watch: {
        isNodeEdit(isNodeEdit) {
            this.shows = isNodeEdit;
        },
    },
};
</script>

<style></style>
